import * as types from './action-types'

export const fetchCities = () => ({
  type: types.CITIES_FETCH_BEGIN,
})
